const HeaderValidation = require('./header/HeaderValidation');
const transferPixWithKeyHeaders = require('./header/transferPixWithKeyHeaders');

class TransferPixWithKeyValidation {
  constructor(data) {
    this._data = data;
    this._headerValidation = new HeaderValidation(this._data, Object.values(transferPixWithKeyHeaders));
  }

  validate() {
    return this._headerValidation.validate();
  }
}

module.exports = TransferPixWithKeyValidation;
